import { Route, Switch, Redirect } from 'quartz-routing/react-router';
import { usePathname, useLocationWithSelector } from 'quartz-routing';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { TicketListings } from '../containers/TicketListings';
import { TicketDetails } from '../containers/TicketDetails';
import { TicketCreationPanel } from './TicketCreationPanel';
import { ROUTES } from '../constants/routes';
import { BreadcrumbContainer } from './BreadcrumbContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Routes() {
  const pathname = usePathname();
  const search = useLocationWithSelector(loc => loc.search);
  const hash = useLocationWithSelector(loc => loc.hash);
  const normalizedPathname = pathname.replace(/\/+/g, '/');
  if (normalizedPathname !== pathname) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: normalizedPathname,
        search,
        hash
      }
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: ROUTES.ticket,
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          blockSize: "100%",
          children: [/*#__PURE__*/_jsx(BreadcrumbContainer, {}), /*#__PURE__*/_jsx(NavMarker, {
            name: "TICKET_LOAD",
            children: /*#__PURE__*/_jsx(TicketDetails, {})
          })]
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: [ROUTES.root, ROUTES.new],
        exact: true,
        component: TicketListings
      }), /*#__PURE__*/_jsx(Redirect, {
        to: ROUTES.root
      })]
    }), /*#__PURE__*/_jsx(Route, {
      path: ROUTES.new,
      component: TicketCreationPanel
    })]
  });
}